/* Winspace: colour swatches on the swatch product grid.
   Swaps the card's image to the actual variant photo for the clicked colour.
   Scoped to .swatch-card markup only, so it cannot touch Dawn's standard cards.
   If a variant has no image its swatch carries no data-variant-image and is
   inert: the dot still shows, the click does nothing. */
(function () {
  'use strict';

  if (window.__winspaceSwatchCardInit) return;
  window.__winspaceSwatchCardInit = true;

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var swatch = target.closest('[data-swatch-card-button]');
    if (!swatch) return;

    var card = swatch.closest('.swatch-card');
    if (!card) return;

    var group = swatch.closest('.swatch-card__swatches');
    if (group) {
      var buttons = group.querySelectorAll('.swatch-card__swatch');
      for (var i = 0; i < buttons.length; i++) {
        buttons[i].classList.remove('is-active');
      }
    }
    swatch.classList.add('is-active');

    var imageUrl = swatch.getAttribute('data-variant-image');
    if (!imageUrl) return;

    var img = card.querySelector('[data-swatch-card-image]');
    if (!img) return;

    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.src = imageUrl;
  });
})();
